import { map } from 'rxjs/operators';
import { ReportRecord } from '../../../../../models/report.model';
import { LovValues } from '../../../../../models/template.model';
import { displayFnWrapper, mapAndFormatDynamicValue } from '../../../utils/dynamic-data-retrievers';
import { currencyLov, PropertyType, valueWithUomPrefix } from '../../us/us.common';

export const displayFnMap = {
  459: {
    // 459 - status
    // clear
    displayFn: (record: ReportRecord, _, status) => {
      return status.lovValues.pipe(
        map((lovs: LovValues[]) => {
          const lovKeyValue = mapAndFormatDynamicValue(record, status, lovs);
          const lovValue = lovs.find(a => a.key === lovKeyValue);
          return lovValue ? lovValue.value : '';
        })
      );
    },
  },
  460: {
    // 460 - year built
    // clear
    displayFn: (record: ReportRecord, options, yearBuilt) => {
      const value = displayFnWrapper(record, options, yearBuilt);
      return Array.isArray(value) ? value.join(', ') : value;
    },
  },
  461: {
    // 461 - Class
    // clear
    displayFn: (record: ReportRecord, _, classArg) => {
      return classArg.lovValues.pipe(
        map((lovs: LovValues[]) => {
          const lovKeyValue = mapAndFormatDynamicValue(record, classArg, lovs);
          const lovValue = lovs.find(a => a.key === lovKeyValue);
          return lovValue ? lovValue.value : '-';
        })
      );
    },
  },
  504: {
    // 504 - date available
    // clear
    displayFn: displayFnWrapper,
  },
  462: {
    // 462 - Average Direct Asking Rate Yearly
    // clear
    displayFn: (record: ReportRecord, options, askingRateYearly) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const value = valueWithUomPrefix(record, PropertyType.Office, askingRateYearly, currencyLOV);
          return Array.isArray(value) ? value.join(', ') : value;
        })
      );
    },
  },
  464: {
    // 464 - Service Charge
    // clear
    displayFn: (record: ReportRecord, options, serviceCharge) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const value = valueWithUomPrefix(record, PropertyType.Office, serviceCharge, currencyLOV);
          return Array.isArray(value) ? value.join(', ') : value;
        })
      );
    },
  },
  457: {
    // 457 - description
    // TODO: BE needs to support colloquial and not colloquial (currently only sending colloquial)
    displayFn: displayFnWrapper,
  },
  503: {
    // 503 - location transport
    // clear
    displayFn: displayFnWrapper,
  },
  472: {
    // 472 - Floor Label
    // clear
    displayFn: displayFnWrapper,
  },
  473: {
    // 473 - Usage Label
    // clear
    displayFn: displayFnWrapper,
  },
  474: {
    // 474 - Sqm label
    // clear
    displayFn: displayFnWrapper,
  },
  475: {
    // 475 - Available Label
    // clear
    displayFn: displayFnWrapper,
  },
  466: {
    // 466 - Parking Space
    displayFn: displayFnWrapper,
  },
};
